import { BuilderService } from '../builder-services/builder.service'
import { CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router'
import { Injectable } from '@angular/core'
import { LoginService } from '../login/login.service'
import { MatDialog } from '@angular/material/dialog'
import { WorksDialogComponent } from '../pages/works-dialog/works-dialog.component'

@Injectable({
  providedIn: 'root'
})
export class BusinessModelGuard implements CanActivate {
  constructor(private builderService: BuilderService, private router: Router, private loginService: LoginService, private dialog: MatDialog) {}

  private howItWorksDialog() {
    const dialogRef = this.dialog.open(WorksDialogComponent, {
      width: '1050px',
      maxWidth: '90%',
      data: { name: 'restrictedPage' }
    })
    dialogRef.afterClosed().subscribe(() => {
      console.log('The dialog was closed')
    })
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    const currentUser = this.loginService.getCurrentUser()
    const restrictedPages = this.builderService.restrictedPages || []

    // Allow admins to bypass this guard
    if (currentUser?.admin) {
      return true
    }
    // Check if the current route matches any restricted page
    if (restrictedPages.some((page: any) => state.url.startsWith(page))) {
      console.log(`Access denied: URL ${state.url} is restricted`)
      this.howItWorksDialog()
      return false
    }

    console.log(`Access granted: URL ${state.url} is allowed`)
    return true
  }
}
